import React, { useState } from 'react'
import './styles.scss'

export const ReadMore = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={`readMore ${isOpen ? 'open' : ''}`}>
      <div className='content'>
        {text}
        <div className='mask' />
      </div>
      {!isOpen && (
        <div
          onClick={() => {
            setIsOpen(true)
          }}
        >
          <i className='ui icon file alternate' />{' '}
          <span className='pseudo-link inverted'>Lire le témoignage</span>{' '}
          <i className='ui icon angle right' />
        </div>
      )}
    </div>
  )
}
